import request from '../kernel/request'

export default {
	plvyo: {
		save(data) {
			return request.post(`plvyo/save`, data)
		},
	}
}